module.exports = __webpack_public_path__ + "img/c4010c6.jpg";